import LogCannon from '@ace-clublabs/log-cannon';
import axios from 'axios';
import { IGetTransactionStatusRequest, ErrorType } from '../../shared/types';
import CookieHelper from '../../utils/cookieHelper';
import { GetTransactionStatus } from '../contracts';
import { createAxiosConfig } from '../mockHelper';

export const GetTransactionStatusApi =
  (endpoint: string): GetTransactionStatus =>
  async ({ transactionId }: IGetTransactionStatusRequest) => {
    try {
      const scenario = CookieHelper.getCookie('scenario');
      LogCannon.blast('GetTransactionStatusApi scenario', { scenario });
      LogCannon.blast('GetTransactionStatusApi start', { endpoint });
      const modifiedEndPoint = `${endpoint}/${transactionId}`;
      await axios.get(modifiedEndPoint, createAxiosConfig(scenario, modifiedEndPoint));
      LogCannon.blast('GetTransactionStatusApi success');
      return Promise.resolve({});
    } catch (error: any) {
      LogCannon.error('GetTransactionStatusApi error', error);

      return Promise.reject({
        message: error,
        type: ErrorType.SYSTEM_ERROR,
      });
    }
  };
